/* eslint-disable max-len */
import React, { useCallback, useState } from 'react';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { BetterDropButton, DropButton } from '../../../ui/DropButton';
import { Position } from '../../../ui/Position';
import { useResolve } from '../../Container';
import { useEditorSessionObserver } from '../../canvas/EditorSession';
import { toolEquip, toolReset } from '../../canvas/tooling/ToolCommands';
import { ToolInfo } from '../../canvas/tooling/ToolInfo';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { EmojiDataPlus, EmojiSelector } from '../../canvas/ui/EmojiSelector';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { eraserTool } from '../marker/EraserTool';

const CloseButton = ({ onClick }: { onClick: () => void }) => {
    return <BetterDropButton padding=".125" overflow=".125" onClick={onClick} style={{ color: Colors.text }}>
        <Icon src="deqo://icons/hero/x" size="1.5" />
    </BetterDropButton>;
};

export const ReactionWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useResolve(ToolManager);

    const activeTool = useEditorSessionObserver(ToolInfo);
    const [selected, setSelected] = useState<EmojiDataPlus | undefined>(undefined);

    const onSelect = useCallback((e: EmojiDataPlus) => {
        setSelected(e);
        tools.setSetting('reactionTool', 'value', e.id);
        dispatch(toolEquip, ['reactionTool']);
    }, [widget, setSelected]);

    const onEquipEraser = useCallback(() => {
        setSelected(null);
        dispatch(toolEquip, ['eraserTool']);
    }, []);

    const onClose = useCallback(() => {
        widget.update({ open: false });
        dispatch(toolReset);
    }, [widget.open]);

    return <Flexer className="consumeWheel" relative>
        <EmojiSelector selected={selected} onSelect={onSelect} />
        <Position inset=".375" at="topRight">
            <Flexer flex="row" align="center" gap=".5">
                <CloseButton onClick={onClose} />
            </Flexer>
        </Position>
        <Position inset="0" at="bottomRight">
            <Flexer flex="row" align="center" gap=".5" padding=".375 .5">
                <DropButton active={activeTool.id === eraserTool.id} onClick={onEquipEraser} padding=".125 .25" overflow="0">
                    <Flexer flex="row" align="center" gap=".375">
                        <Icon src="deqo://icons/i8/eraser" size="1" />
                        Eraser
                    </Flexer>
                </DropButton>
            </Flexer>
        </Position>
    </Flexer>;
});
